<template>
  <ContentLayout>
    <pdf-viewer source="./pdf/INI.pdf" />
    
    <Footer />
  </ContentLayout>
</template>

<script>
import Footer from "../components/Footer";
import ContentLayout from "../components/ContentLayout";

export default {
  components: {
    ContentLayout,
    Footer
  }
};
</script>

<style lang="scss" scoped>
</style>
